import type {
  TeaserBaseProps,
  TeaserHighlightProps,
  TeaserMediaProps,
  TeaserTextProps,
  TeaserThemeProps,
  TeaserVignetteProps,
} from '@bonniernews/dn-design-system-web/assets/types/teaser-props.ts'

import { formatClassString } from '@bonniernews/dn-design-system-web/helpers/formatClassString.ts'
import { Body, Content, Media, Title, Vignette } from '@bonniernews/dn-design-system-web/helpers/teaser.tsx'

import { TeaserCard } from '@bonniernews/dn-design-system-web/components/teaser-card/teaser-card.tsx'

export interface TeaserCenteredProps
  extends TeaserBaseProps,
    TeaserThemeProps,
    TeaserHighlightProps,
    TeaserVignetteProps,
    TeaserMediaProps,
    TeaserTextProps {
  areaType?: 'main' | 'bauta'
}

/**
 * - GitHub: [BonnierNews/dn-design-system/web/src/components/teaser-centered](https://github.com/BonnierNews/dn-design-system/tree/main/web/src/components/teaser-centered)
 * - Storybook: [Teasercentered](https://designsystem.dn.se/?path=/docs/section-teasercentered--docs)
 *
 * The component will not include styling by itself. Make sure to include the right styles for the component. See example below:
 * `@use '@bonniernews/dn-design-system-web/components/teaser-centered/teaser-centered.scss'`
 */
export const TeaserCentered = ({
  areaType,
  targetLink,
  theme = 'nyheter',
  classNames,
  attributes,
  media,
  title,
  text,
  vignette,
  highlight,
}: TeaserCenteredProps) => {
  const classes = formatClassString(['ds-teaser--centered', !!media && 'ds-teaser--hide-top-border', classNames])

  return (
    <TeaserCard areaType={areaType} targetLink={targetLink} theme={theme} classNames={classes} attributes={attributes}>
      <Media media={media} />
      <Content>
        <Vignette vignette={vignette} />
        <Title title={title} highlight={highlight} />
        <Body text={text} />
      </Content>
    </TeaserCard>
  )
}
